import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appCloseMenuOnScroll]',
  standalone: true,
})
export class CloseMenuOnScrollDirective {
  @Input() menu: { hide: () => void };
  @HostListener('document:scroll', ['$event'])
  onScroll() {
    this.menu.hide();
  }
}
